export const opcoesVendas = [
    "Percebe a necessidade de consumir o produto",
    "Indicação Impacto eventos",
    "Redes sociais",
    "Site",
    "Acesso Whatsapp",
    "Mandar mensagem",
    "Marca visita no local",
    "Fazer visita no local",
    "Marcar Apresentação do orçamento",
    "Apresentar Orçamento",
    "Entrar em contato 5 dias após",
    "Fechou venda",
]

export const opcoesLevantamento = {
    "Interiores":[
        "Medições do ambiente existente",
        "Registro fotográfico",
        "Levantamento de mobiliário existente",
        "Consulta às normas aplicáveis",
        "Programa de necessidades com cliente",
        "reuniões iniciais",
        "Contato adicional (e-mail/WhatsApp)"
    ],
    "Exteriores":[
        "Medições do terreno e áreas externas",
        "Registro fotográfico do entorno",
        "Levantamento topográfico/planialtimétrico",
        "Análise de insolação, ventos e drenagem",
        "Programa de necessidades com cliente",
        "reunião inicial",
        "Contato adicional (e-mail/WhatsApp)"
    ],
    "Arquitetônico":[
        "Medições do terreno e construções",
        "Registro fotográfico e planialtimétrico",
        "Consulta a legislações e códigos",
        "Programa de necessidades",
        "reunião inicial",
        "Contato adicional (e-mail/WhatsApp)"
    ]
}

export const opcoesEstudoPreliminar = {
    "Interiores":[
        "Interpretação do programa de necessidades",
        "Definição do conceito/estilo do projeto",
        "Croquis e estudos de layout",
        "Moodboard (referências visuais)",
        "reunião de apresentação",
        "Contato digital para feedback",
    ],
    "Exteriores":[
        "Interpretação do programa de necessidades",
        "Definição de conceito paisagístico",
        "Croquis de implantação e fluxos",
        "Estudos volumétricos e diagramas de vegetação",
        "reunião de apresentação",
        "Contato digital para feedback"
    ],
    "Arquitetônico":[
        "Interpretação do programa",
        "Definição do partido arquitetônico",
        "Croquis e estudos volumétricos",
        "Plantas, cortes e perspectivas simples",
        "Reunião de apresentação",
        "Contato digital para feedback"
    ]
}

export const opcoesAnteprojeto = {
    "Interiores":[
        "Layout definido (mobiliário e circulação)",
        "Proposta de acabamentos e cores",
        "Estudo de iluminação preliminar",
        "Plantas, cortes, perspectivas 3D",
        "Estimativa inicial de custos",
        "reunião de apresentação",
        "reunião de validação",
        "Contato digital para ajustes"
    ],
    "Exteriores":[
        "Layout geral de jardins, pisos e mobiliário externo",
        "Seleção preliminar de espécies vegetais",
        "Estudo de iluminação e irrigação preliminar",
        "Plantas, cortes e perspectivas ilustrativas",
        "Estimativa inicial de custos",
        "Reunião de apresentação",
        "Reunião de validação",
        "Contato digital para ajustes"
    ],
    "Arquitetônico":[
        "Definição de implantação e espaços",
        "Indicação preliminar de materiais",
        "Pranchas (plantas, cortes, fachadas)",
        "Estimativa de custos iniciais",
        "Reunião de apresentação",
        "Reunião de validação",
        "Contato digital para ajustes"
    ]
}


export const opcoesProjetoLegal = {
    "Interiores":[],
    "Exteriores":[],
    "Arquitetônico":[
        "Plantas, memoriais e RRT",
        "Tramitação em órgãos públicos",
        "reunião breve",
        "Contato digital para atualizações"
    ]
}

export const opcoesProjetoExecutivo ={
    "Interiores":[
        "Plantas detalhadas de layout",
        "Detalhamentos de marcenaria e mobiliário fixo",
        "Paginação de pisos, revestimentos e forros",
        "Projeto luminotécnico e pontos elétricos",
        "Memorial descritivo e especificações",
        "reunião de alinhamento",
        "reunião de entrega final",
        "Contato digital para ajustes"
    ],
    "Exteriores":[
        "Plantas detalhadas de implantação",
        "Detalhes construtivos (pisos, decks, pergolados etc.)",
        "Especificação de espécies vegetais",
        "Projeto de irrigação e luminotécnico externo",
        "Memorial descritivo e planilhas de quantitativos",
        "Reunião de alinhamento ",
        "Reunião de entrega final ",
        "Contato digital para ajustes"
    ],
    "Arquitetônico":[
        "Desenhos técnicos detalhados",
        "Compatibilização de complementares",
        "Memoriais e planilhas de quantitativos",
        "Reunião de alinhamento",
        "Reunião final de apresentação",
        "Contato digital para ajustes"
    ]
}

export const opcoesAcompanhamentoObras = {
    "Interiores":[
        "Reunião de alinhamento",
        "Entrega do check list da etapa projeto executivo",
        "Desenho do projeto executivo",
        "Montar Pranchas para execução e projeto legal",
        "Conferência do projeto com o check list",
        "Alteração do projeto",
        "Montar caderno de apresentação do projeto",
        "Marcar reunião",
        "Dia da reunião e entrega do projeto",
        "Dia de alinhamento com os executores da obra"
    ],
    "Exteriores":[
        "Visitas técnicas periódicas",
        "Orientação sobre execução e plantio",
        "Verificação de conformidade com o projeto",
        "Apoio na compra de espécies e materiais",
        "Relatórios pós-visita e contato digital constante",
    ],
    "Arquitetônico":[
        "Visitas técnicas periódicas",
        "Orientação e esclarecimento de dúvidas",
        "Verificação de conformidade da obra",
        "Visitas programadas",
        "Relatórios e contato digital constante"
    ]
}

export const opcoesCustosAdicionais = [
    "Deslocamento",
    "Taxas de cartório",
    "Laudos específicos",
    "Revisões extras",
];

export const opcoesFinAdm = [
    "Realização dos boletos a receber",
    "Alimentação do financeiro",
    "Cobranças e avisos prévios"
]

export const opcoesTipoProjeto = [
    "Arquitetônico", "Exteriores", "Interiores"
]

export const etapasProjeto = {
    "Arquitetônico":["Introdução", "Dados do Cliente", "Venda", "Levantamento","Estudo Preliminar", "Anteprojeto","Projeto Legal","Projeto Executivo","Acompanhamento de Obra", "Custos Adicionais"],
    "Exteriores":["Introdução", "Dados do Cliente", "Venda", "Levantamento","Estudo Preliminar", "Anteprojeto","Projeto Executivo","Acompanhamento de Obra", "Custos Adicionais"],
    "Interiores":["Introdução", "Dados do Cliente", "Venda", "Levantamento","Estudo Preliminar", "Anteprojeto","Projeto Executivo","Acompanhamento de Obra", "Custos Adicionais"],
}
